import React, { useEffect, useState } from "react";
import "../LandingPage/LandingPage.css";
import Footer from "../../Components/Footer/FooterSmall";
import Header from "../../Components/Header2/Header2";
import "./Reports.css";
import { Link, useNavigate } from "react-router-dom";
import { useUser } from "../../Context/UserContext";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import useAPI from "../../Hooks/useAPI";
import DropDown from "../../Components/DropDown.css/DropDown";
import Button from "../../Components/Button/Button";

const Reports: React.FC = () => {
  const { getUserInfoReportsList, getUserInfoReport } = useAPI();
  const [reportsList, setReportsList] = useState<
    { value: string; label: string }[]
  >([]);
  const [selectedReport, setSelectedReport] = useState("");

  const { user } = useUser();
  const navigate = useNavigate();

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleReasonChange = (value: string) => {
    console.log("Parent received:", value);
    setSelectedReport(value);
  };

  useEffect(() => {
    const fetchReports = async () => {
      try {
        // Fetch the report list from your API
        const body = await getUserInfoReportsList();

        if (Array.isArray(body.files)) {
          // 2️⃣ Transform string list into value/label objects
          const mappedReasons = body.files.map((reason: string) => ({
            value: reason,
            label: reason,
          }));

          // 3️⃣ Save it in state
          setReportsList(mappedReasons);
        } else {
          console.warn("Unexpected response format:", body);
          setReportsList([]);
        }

        // ✅ If you want to fetch the first report as a Blob
        if (body.files?.length > 0) {
          const excelBlob = await getUserInfoReport(body.files[0]);
          console.log("excelBlob:", excelBlob);
        }

        console.log("reports list:", body.files);
      } catch (err) {
        setError(err instanceof Error ? err.message : "An error occurred");
      }
    };

    fetchReports();
  }, [getUserInfoReportsList, getUserInfoReport]); // ✅ dependency fix

  const downloadFile = async () => {
    try {
      if (selectedReport != "") {
        const excelBlob = await getUserInfoReport(selectedReport);

        // Create a temporary URL for the blob
        const url = window.URL.createObjectURL(excelBlob);

        // Create a hidden <a> element to trigger the download
        const a = document.createElement("a");
        a.href = url;
        a.download = selectedReport; //body.files[0]; // filename for the downloaded Excel
        document.body.appendChild(a);
        a.click();

        // Cleanup
        a.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth", // Optional: Adds a smooth scrolling animation
  });
  return (
    <div className="generalPage">
      <div className="landingPage">
        <Header />
        <div className="form-container">
          <div>
            <h2>User Activity Report:</h2>
            <DropDown
              label="Report"
              id="reason"
              options={reportsList}
              name="reason"
              onChange={handleReasonChange}
            />
            {selectedReport && (
              <Button
                name="send"
                text="Send"
                type=""
                onClick={downloadFile}
                iconPath={faDownload}
              />
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Reports;
function setError(arg0: string) {
  throw new Error("Function not implemented.");
}
